// extracted by mini-css-extract-plugin
export default {"SubjectsBySemester":"vC9PND37LwpKEuTQzv1O","Heading":"fVPlbXHibtRCK7BkSpeP","SemesterList":"QSqBZbAXU5b_c9GeXu3_"};